<script lang="ts">
    import type {Writable} from "svelte/store";
    import type {Employee, EmployeeExtra} from "$lib/types/employee";
    import {enhance} from "$app/forms";
    import CardLayout from "$items/CardLayout.svelte";
    import InfoBox from "$items/InfoBox.svelte";
    import {getContext, onMount} from "svelte";
    import VerticalGrid from "$lib/components/VerticalGrid.svelte";
    import {Alert, Button, Input} from "flowbite-svelte";
    import {PenOutline} from "flowbite-svelte-icons";
    import ApplyTrigger from "$items/employee/ApplyTrigger.svelte";
    import type {Employee} from "$lib/types/employee";
    import IncompleteDataWarning from "$lib/components/IncompleteDataWarning.svelte";
    import CardLayoutSubmitButton from "$items/employee/form/CardLayoutSubmitButton.svelte";

    export let readOnly = false;
    const employee: Writable<Employee> = getContext('employee');
    const super_edit: Writable<boolean> = getContext('super_edit');
    let loading = false;

    let display = false;

    let complete = false;

    let validationError = false;

    const employee_extra: Writable<EmployeeExtra> = getContext('employee_extra')

    $: complete = !!($employee.bankAccount && $employee.bankAccount.accountName && $employee.bankAccount.iban && $employee.bankAccount.bicSwift)

    const getBankDetails = () => {
        if($employee?.bankAccount?.iban) {
            validationError = false;
            fetch(`https://openiban.com/validate/${$employee.bankAccount.iban}?getBIC=true&validateBankCode=true`).then(j => j.json()).then(j => {
                if(!j.valid || j.bankData.name === "") {
                    validationError = true;
                } else {
                    $employee.bankAccount.bankName = j.bankData.name
                    $employee.bankAccount.bicSwift = j.bankData.bic
                    $employee.bankAccount.city = j.bankData.city
                    $employee.bankAccount.zip = j.bankData.zip
                }

            })
        }
    }
    onMount(() => {
        getBankDetails()
    })


</script>

<CardLayout title="Zahlungsart" bind:display accordion>
    <svelte:fragment slot="card-header">
        <IncompleteDataWarning {complete}/>
        {#if !readOnly}
            <Button color="yellow" class="!p-2" pill outline on:click={() => $super_edit = !$super_edit}>
                <PenOutline class="w-4 h-4"/>
            </Button>
        {/if}
    </svelte:fragment>
    <form class="px-2 py-3" method="post" class:opacity-20={loading}
          use:enhance={() => {loading=true;return ({ update }) => {loading=false; update({ reset: false })}}}
          action="?/update_bank_info">
        <VerticalGrid>
            <InfoBox title="Kontoinhaber" name="accountName"
                     value={$employee?.bankAccount?.accountName}
            />
            <InfoBox title="BIC/SWIFT" name="bicSwift"
                     value={$employee?.bankAccount?.bicSwift}
            />
            <InfoBox title="Bank" name="bankName" value={$employee?.bankAccount?.bankName}/>

            <svelte:fragment slot="right">
                {#if $employee.bankAccount}
                <InfoBox title="IBAN" name="iban" value={$employee?.bankAccount?.iban}>
                    <Input type="text" on:input={() => getBankDetails()} name="iban" class="w-full py-1 pl-1" bind:value={$employee.bankAccount.iban}/>
                </InfoBox>
                <InfoBox readonly title="PLZ" value={$employee?.bankAccount?.zip}/>
                <InfoBox readonly title="Ort" value={$employee?.bankAccount?.city}/>
                {/if}
        {#if $super_edit}
            <CardLayoutSubmitButton/>
            <ApplyTrigger {loading}/>
        {/if}

            </svelte:fragment>
        </VerticalGrid>
        {#if validationError}
            <div class="my-3">
                <Alert color="red">Bankdaten konnten nicht automatisiert verifiziert werden. Bitte genau prüfen!</Alert>
            </div>
        {/if}

    </form>
</CardLayout>